export default __webpack_public_path__ + "static/media/qr-code.12d7b80e.jpg";